import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import GenericProfileIcon from 'assets/svgs/genericProfileIcon.svg';

import './AdmissionTicketSample.scss';

const AdmissionTicketSample = ({ testCenterName, location, message }) => {
  const { t } = useTranslation();
  return (
    <div>
      <h5>{t('testCenter.messagesTestDates.admissionTicket.title')}</h5>
      <p className="dark-gray">{t('testCenter.messagesTestDates.admissionTicket.subtitle')}</p>
      <div className="admission-ticket-card">
        <div>
          <GenericProfileIcon />
        </div>
        <div className="admission-ticket-details">
          <div>
            <p className="fw-bold pb-2">
              {t('testCenter.messagesTestDates.admissionTicket.testCenter')}
            </p>
            <p>{testCenterName}</p>
            <p>{location.name}</p>
            <p>{location.area}</p>
            <p>
              {location.address1}
              {location.address2 ? `,${location.address2}` : ''}
              {location.address3 ? `,${location.address3}` : ''}
            </p>
            <p>
              {location.city}, {location.stateCode}, {location.postalCode}
            </p>
          </div>
          <div>
            <p className="fw-bold pb-2">
              {t('testCenter.messagesTestDates.admissionTicket.testCenterMessage')}
            </p>
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionTicketSample;

AdmissionTicketSample.propTypes = {
  testCenterName: PropTypes.string.isRequired,
  location: PropTypes.shape({
    name: PropTypes.string,
    area: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    stateCode: PropTypes.string,
    postalCode: PropTypes.string,
  }).isRequired,
  message: PropTypes.string,
};
